module.exports = __webpack_public_path__ + "img/Osterfeuer.720dbc83.jpg";